import { useDispatch } from "react-redux";
import { ACTION_TYPES } from "../FormData.constants";

const useSetFormData = () => {
    // hooks
    const dispatch = useDispatch();

    // setters
    /**
     * @caution
     * `formData` has type `any` because
     *  the `formData` can be `string,number,or even object with unknown` type
     *  as we are following this format in formData:
     *  `{ key<string>: value<string|number|object>}`
     */
    const setFormData = (formKey: string, formData: any) => {
        dispatch({
            type: ACTION_TYPES.SET_FORM_DATA,
            payload: {
                formKey,
                formData,
            },
        });
    };

    // reset - resets the asks key to '{}'
    const resetFormData = (formKey: string) => {
        dispatch({
            type: ACTION_TYPES.RESET_FORM_DATA,
            payload: {
                formKey,
            },
        });
    };

    // remove - removes the asked key from the main state
    const removeFormData = (formKey: string) => {
        dispatch({
            type: ACTION_TYPES.REMOVE_FORM_DATA,
            payload: {
                formKey,
            },
        });
    };

    return {
        setFormData,
        resetFormData,
        removeFormData,
    };
};

export default useSetFormData;
